import React from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col, Pager, FormControl, Button } from 'react-bootstrap';
import Constants from '../../config/constants';
import { translate } from 'react-i18next';
import Layout from '../../components/layout/Layout';
import ProjectCard from '../../components/projectcard/ProjectCard';
import Card from '../../components/card/Card';
import ProjectCreateModal from '../../modal/projects/ProjectCreateModal';
import ProjectCreateReferenceModal from '../../modal/projects/ProjectCreateReferenceModal';
import InvitationListModal from '../../modal/member/InvitationListModal';
import { defaultRejectHandler } from '../../utils/utility';
import { convertProject } from '../../utils/converter';

import {
  clearErrorProject,
  getProject,
  listAllProject,
} from '../../redux/projects/projects_actions';

import '../../components/default.css';

class ProjectsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowCreateModal: false,
      isShowCreateRefModal: false,
      isShowInvModal: false,
      isCreated: false,
      page: 0,
      searchText: '',
      viewMode: 'card',
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.listProject(this.state.page, this.state.searchText);
  }

  componentWillUnmount() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
    }
  }

  listProject() {
    const { page } = this.state;
    this.props.listProject(page, this.state.searchText);
  }

  nextPage() {
    this.setState({ page: this.state.page + 1 }, () => this.listProject());
  }

  prevPage() {
    this.setState({ page: Math.max(this.state.page - 1, 0)}, () => this.listProject());
  }

  navigateProjectDetail(project) {
    if (project.is_mixed_use) {
      this.props.history.push(`/projects/mixeduse/${project.id}`);
    }
    else {
      this.props.history.push(`/projects/${project.id}`);
    }
  }

  dismissCreateModal() {
    this.props.clearError();
    this.setState({ isShowCreateModal: false });
  }

  dismissCreateRefModal() {
    this.props.clearError();
    this.setState({ isShowCreateRefModal: false });
  }

  dismissInvModal() {
    this.props.clearError();
    this.setState({ isShowInvModal: false });
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isInvAccepting && nextProps.isInvAccepting !== this.props.isInvAccepting && !nextProps.invErrorMessage) {
      this.props.listProject();
    }
    if (this.props.isCreating && nextProps.isCreating !== this.props.isCreating && !nextProps.errorMessage) {
      this.setState({ isShowCreateModal: false, isCreated: true  });
    }
  }

  renderActionMenu() {
    const { t } = this.props;
    return [
      <li key="project-create-menu">
        <a href="#"
          id="project-create"
          data-toggle="modal"
          data-target="#create-project"
          onClick={() => this.setState({ isShowCreateModal: true, isCreated: false })}
        >
          <i className="fas fa-plus-square" />
          <span className="menu-text">{t('create project')}</span>
        </a>
      </li>,
      <li key="project-create-ref-menu">
        <a href="#"
          id="project-create-reference"
          onClick={() => this.setState({ isShowCreateRefModal: true })}
        >
          <i className="fas fa-copy" />
          <span className="menu-text">{t('create project reference')}</span>
        </a>
      </li>,
      <li key="project-invitation">
        <a
          href="#"
          id="project-invitation"
          onClick={() => this.setState({ isShowInvModal: true })}
        >
          <i className="fas fa-inbox" />
          <span className="menu-text">{t('invitation inbox')}</span>
        </a>
      </li>,
    ];
  }

  renderStatusBadge(status) {
    const { t } = this.props;
    const s = status || 'unset';
    const cssClass = s === 'passed' ? 'status-passed' : s === 'failed' ? 'status-failed' : 'status-pending';
    return <span className={'project-status ' + cssClass}>{t(`${s.toLowerCase()} abbr`).toUpperCase()}</span>;
  }

  renderProjectStatusBadge(project, lang) {
    const { t } = this.props;
    const statusMapper = {
      draft: 'status-pending',
      submitted: 'status-passed',
      rejected: 'status-failed',
      approved: 'status-passed',
    };
    const raw = (project.status || '').trim();
    const u = raw.toUpperCase();
    let norm = null;
    if (u === 'DRF' || u === 'DRAFT') norm = 'DRF';
    else if (u === 'SUB' || u === 'SUBMITTED') norm = 'SUB';
    else if (u === 'REJ' || u === 'REJECTED') norm = 'REJ';
    else if (u === 'APP' || u === 'APPROVED') norm = 'APP';

    const label =
      norm === 'DRF' ? (lang === 'th' ? 'ร่าง' : 'Draft')
      : norm === 'SUB' ? (lang === 'th' ? 'เสร็จสิ้น' : 'Done')
      : norm === 'REJ' ? (lang === 'th' ? 'ไม่ผ่านการอนุมัติ' : 'Rejected')
      : norm === 'APP' ? (lang === 'th' ? 'ผ่านการอนุมัติแล้ว' : 'Approved')
      : raw ? t(raw.toLowerCase()) : '';

    const cssClass =
      norm === 'DRF' ? 'status-pending'
      : norm === 'SUB' ? 'status-passed'
      : norm === 'REJ' ? 'status-failed'
      : norm === 'APP' ? 'status-passed'
      : statusMapper[raw.toLowerCase()];
    return (
      <span className={'project-status' + (cssClass ? ` ${cssClass}` : '')} style={{ width: 'auto', whiteSpace: 'nowrap', padding: '3px 8px' }}>
        {label}
      </span>
    );
  }

  renderTableView(filteredProjects) {
    const { t, i18n } = this.props;
    const lang = i18n.language.split('-')[0];
    const defaultStatus = 'unset';

    const centerCell = { textAlign: 'center', verticalAlign: 'middle' };

    return (
      <Card header={t('projects')}>
        <div style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th style={{ textAlign: 'center' }}>ID</th>
                <th>{lang === 'th' ? 'ชื่อโครงการ' : 'Project Name'}</th>
                <th style={{ textAlign: 'center' }}>{t('type')}</th>
                <th style={{ textAlign: 'center' }}>{t('envelop')}</th>
                <th style={{ textAlign: 'center' }}>{t('lighting')}</th>
                <th style={{ textAlign: 'center' }}>{t('A/C')}</th>
                <th style={{ textAlign: 'center' }}>{lang === 'th' ? 'น้ำร้อน' : t('hot water')}</th>
                <th style={{ textAlign: 'center' }}>{t('project status')}</th>
              </tr>
            </thead>
            <tbody>
              {filteredProjects.length === 0 ? (
                <tr>
                  <td colSpan={8} style={{ textAlign: 'center', color: '#999' }}>
                    {t('not found')}
                  </td>
                </tr>
              ) : filteredProjects.map((project, index) => {
                const converted = convertProject(project);
                const { evaluation } = converted;
                const buildingTypeName = converted[`building_type_name_${lang}`] || converted.building_type_name_th || '';
                const envelopStatus = evaluation ? evaluation.envelope.OTTV.status : defaultStatus;
                const lightingStatus = evaluation ? evaluation.lighting_system.status : defaultStatus;
                const acStatus = evaluation ? evaluation.air_conditioning.status : defaultStatus;
                const hotWaterStatus = evaluation ? evaluation.hot_water_system.status : defaultStatus;

                return (
                  <tr key={index}>
                    <td style={{ ...centerCell, color: '#999', fontSize: '0.85em' }}>{project.id}</td>
                    <td
                      style={{ cursor: 'pointer', color: '#00aaff' }}
                      onClick={() => this.navigateProjectDetail(project)}
                    >
                      {converted.name}
                    </td>
                    <td style={centerCell}>{buildingTypeName}</td>
                    <td style={centerCell}>{this.renderStatusBadge(envelopStatus)}</td>
                    <td style={centerCell}>{this.renderStatusBadge(lightingStatus)}</td>
                    <td style={centerCell}>{this.renderStatusBadge(acStatus)}</td>
                    <td style={centerCell}>{this.renderStatusBadge(hotWaterStatus)}</td>
                    <td style={centerCell}>{this.renderProjectStatusBadge(project, lang)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Card>
    );
  }

  render() {
    const {
      projects,
      totalProjectCount,
      t,
      i18n,
    } = this.props;

    const lang = (i18n.language || 'th').split('-')[0];
    const keyword = (this.state.searchText || '').toLowerCase();
    const filteredProjects = projects
      ? projects.filter(p => (p.name || '').toLowerCase().indexOf(keyword) !== -1)
      : [];
    const isEnablePrevBtn = this.state.page !== 0;
    const pageSize = 10;
    const isEnableNextBtn = (this.state.page + 1) * pageSize < totalProjectCount;
  
    const breadcrumbItems = [
      { name: t('projects'), path: '/projects' },
    ];

    const helpConfig = {
      title: t('help'),
      contentUrl: '/html/help_project.html',
    };

    const { viewMode } = this.state;

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
        renderActionMenu={() => this.renderActionMenu()}
        help={helpConfig}
      >
        <Grid>
          <Row style={{ marginBottom: 15, display: 'flex', alignItems: 'center' }}>
            <Col xs={12} sm={6} md={4} lg={3}>
              <FormControl
                type="text"
                placeholder={t('search name')}
                value={this.state.searchText}
                onChange={e => {
                  const value = e.target.value;
                  this.setState({ searchText: value, page: 0 }, () => {
                    if (this.searchTimer) clearTimeout(this.searchTimer);
                    this.searchTimer = setTimeout(() => {
                      this.listProject();
                    }, Constants.DEBOUNCE_TIME || 250);
                  });
                }}
              />
            </Col>
            <Col xs={12} sm={6} md={8} lg={9}>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  title={lang === 'th' ? 'แบบการ์ด' : 'Card view'}
                  onClick={() => this.setState({ viewMode: 'card' })}
                  style={{
                    padding: '6px 13px',
                    background: viewMode === 'card' ? '#00aaff' : '#fff',
                    color: viewMode === 'card' ? '#fff' : '#888',
                    border: '1px solid #dfdfdf',
                    borderRight: 'none',
                    borderRadius: '4px 0 0 4px',
                    boxShadow: 'none',
                    transition: 'background 0.15s',
                  }}
                >
                  <i className="fas fa-th-large" />
                </Button>
                <Button
                  title={lang === 'th' ? 'แบบตาราง' : 'Table view'}
                  onClick={() => this.setState({ viewMode: 'table' })}
                  style={{
                    padding: '6px 13px',
                    background: viewMode === 'table' ? '#00aaff' : '#fff',
                    color: viewMode === 'table' ? '#fff' : '#888',
                    border: '1px solid #dfdfdf',
                    borderRadius: '0 4px 4px 0',
                    boxShadow: 'none',
                    transition: 'background 0.15s',
                  }}
                >
                  <i className="fas fa-list" />
                </Button>
              </div>
            </Col>
          </Row>
          <Row>
            <ProjectCreateModal
              show={this.state.isShowCreateModal}
              onHide={() => this.dismissCreateModal()}
            />
            <ProjectCreateReferenceModal
              show={this.state.isShowCreateRefModal}
              onHide={() => this.dismissCreateRefModal()}
            />
            <InvitationListModal
              show={this.state.isShowInvModal}
              onHide={() => this.dismissInvModal()}
            />
            {viewMode === 'card' ? (
              filteredProjects
                ? filteredProjects.map((project, index) => (
                    <Col xs={12} sm={6} md={4} lg={3} key={index}>
                      <ProjectCard
                        project={convertProject(project)}
                        onClick={() => this.navigateProjectDetail(project)}
                      />
                    </Col>
                  ))
                : null
            ) : (
              <Col xs={12}>
                {this.renderTableView(filteredProjects)}
              </Col>
            )}
          </Row>
          <Row style={{ justifyContent: 'center' }}>
            <Pager>
              <Pager.Item href="#" disabled={!isEnablePrevBtn} onClick={() => this.prevPage()}>
                {t("previous")}
              </Pager.Item>{' '}
              <Pager.Item href="#" disabled={!isEnableNextBtn} onClick={() => this.nextPage()}>
                {t("next")}
              </Pager.Item>
            </Pager>
          </Row>
        </Grid>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  projects: state.project.orderedIds.map(id => state.project.objects[id]),
  totalProjectCount: state.project.totalCount,
  errorMessage: state.project.errorMessage,
  isInvAccepting: state.projectInvitation.isAccepting,
  invErrorMessage: state.projectInvitation.errorMessage,
  isCreating: state.project.creating,
});

const mapDispatchToProps = dispatch => ({
  listProject: (page, searchText) => defaultRejectHandler(dispatch(listAllProject(page, 10, searchText))),
  getProject: id => defaultRejectHandler(dispatch(getProject(id))),
  clearError: () => dispatch(clearErrorProject()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ProjectsPage),
);



// WEBPACK FOOTER //
// ./src/pages/projects/ProjectsPage.js